import { render } from "./AnswerTopTitle.vue?vue&type=template&id=168838a0&scoped=true&ts=true"
import script from "./AnswerTopTitle.vue?vue&type=script&lang=ts"
export * from "./AnswerTopTitle.vue?vue&type=script&lang=ts"

import "./AnswerTopTitle.vue?vue&type=style&index=0&id=168838a0&scoped=true&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168838a0"]])

export default __exports__